import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { GetIntegrationAgencySettingsResponseTO } from 'models/InternalIntegrationSetting';
import API from 'services/API';
import { INTERNAL_INTEGRATION_SETTINGS_BASE_QUERY_KEY } from '../pages/channels/integrationSettingsQuery';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetIntegrationAgencySettingsResponseTO>,
  'queryKey' | 'queryFn'
>;

type UseFetchIntegrationArgs = {
  enumId: GetIntegrationAgencySettingsResponseTO['enumId'];
} & ReactQueryOptions;

export const INTEGRATION_AGENCY_SETTINGS_QUERY_KEY =
  'integration-agency-settings';

export const getIntegrationAgencySettingsQueryKey = ({
  enumId,
}: {
  enumId: GetIntegrationAgencySettingsResponseTO['enumId'];
}) => [
  INTERNAL_INTEGRATION_SETTINGS_BASE_QUERY_KEY,
  INTEGRATION_AGENCY_SETTINGS_QUERY_KEY,
  'detail',
  { enumId },
];

const useFetchIntegrationAgencySettings = ({
  enumId,
  enabled = true,
  ...options
}: UseFetchIntegrationArgs) => {
  return useAppQuery<GetIntegrationAgencySettingsResponseTO>({
    queryKey: getIntegrationAgencySettingsQueryKey({ enumId }),
    queryFn: async () => {
      const response = await API.get<GetIntegrationAgencySettingsResponseTO>(
        `/api/internal/integrations/default/${enumId}/agency-settings`,
      );

      return response.data;
    },
    enabled,
    staleTime: 30000,
    ...(options ?? {}),
  });
};

export default useFetchIntegrationAgencySettings;
